const menus = JSON.parse(localStorage.getItem("apps") ?? "[]");

export const navigations = [
  { key : "m1", name: 'Dashboard', path: '/dashboard', icon: 'dashboard' },
  {
    key : "m2",
    name : 'Management Data',
    icon : 'layers',
    children : menus?.find(m => Number(m.id) === 1)?.children || []
  },
  {
    key : "m3",
    name : 'Project Document',
    icon : 'art_tracks',
    children : menus?.find(m => Number(m.id) === 2)?.children || []
  },
  { 
    key : "m4", 
    name: 'Communication',
    icon: 'library_books',
    children: menus?.find(m => Number(m.id) === 15)?.children || []
  },
  { 
    key : "m5", 
    name: 'Reporting',
    icon: 'library_books',
    children: menus?.find(m => Number(m.id) === 3)?.children || []
  },
  { 
    key : "m6", 
    name: 'Document Stamp',
    icon: 'library_books',
    children: menus?.find(m => Number(m.id) === 19)?.children || []
  },
  { 
    key : "m7", 
    name: 'Guidelines', 
    icon: 'live_help',
    children: [
        {
          menu_id: 91,
          name: "Memosign Usage Guide",
          path: "/user-guide",
          iconText: "UG"
        },
        {
          menu_id: 92,
          name: "LOA Usage Guide",
          path: "/user-guide-loa",
          iconText: "UL"
        }
    ] 
  }
];
